import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import usePullToRefresh from '../hooks/usePullToRefresh';
import toast from 'react-hot-toast';

const DashboardPage = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newProject, setNewProject] = useState({ name: '', description: '' });
  const navigate = useNavigate();

  const fetchProjects = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/api/projects');
      setProjects(data);
    } catch (error) {
      console.error('Failed to fetch projects', error);
      toast.error('Failed to load projects');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  usePullToRefresh(fetchProjects);

  const handleCreateProject = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post('/api/projects', newProject);
      setProjects([data, ...projects]);
      setShowCreateModal(false);
      setNewProject({ name: '', description: '' });
      toast.success('Project created successfully');
      navigate(`/projects/${data.id}`);
    } catch (error) {
      toast.error('Failed to create project');
    }
  };

  return (
    <div className="dashboard">
      <div className="dashboard__header">
        <h1>My Merge Projects</h1>
        <button
          className="btn btn--primary"
          onClick={() => setShowCreateModal(true)}
        >
          New Project
        </button>
      </div>

      {loading ? (
        <section className="card-grid">
          {[1, 2, 3].map(i => (
            <div key={i} className="skeleton skeleton-card" />
          ))}
        </section>
      ) : (
        <div className="card-grid">
          {projects.length > 0 ? (
            projects.map((project) => (
              <div
                key={project.id}
                className="card project-card"
                onClick={() => navigate(`/projects/${project.id}`)}
              >
                <h3>{project.name}</h3>
                <p>{project.description || 'No description'}</p>
                <div className="project-card__meta">
                  <span>Created: {new Date(project.created_at).toLocaleDateString()}</span>
                </div>
              </div>
            ))
          ) : (
            <div className="empty-state">
              <p>No projects found. Create your first project to get started!</p>
            </div>
          )}
        </div>
      )}

      {showCreateModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Create New Project</h2>
            <form onSubmit={handleCreateProject}>
              <div className="form-group">
                <label>Project Name</label>
                <input
                  type="text"
                  value={newProject.name}
                  onChange={(e) => setNewProject({ ...newProject, name: e.target.value })}
                  placeholder="e.g., Asthma Policy Merger"
                  required
                />
              </div>
              <div className="form-group">
                <label>Description (Optional)</label>
                <textarea
                  value={newProject.description}
                  onChange={(e) => setNewProject({ ...newProject, description: e.target.value })}
                  placeholder="What is this merger for?"
                />
              </div>
              <div className="modal__actions">
                <button type="button" className="btn" onClick={() => setShowCreateModal(false)}>Cancel</button>
                <button type="submit" className="btn btn--primary">Create Project</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardPage;
